/** 批量派券 - 选择弹窗配置（用户分组 / 认证企业 / 大学生认证） */

export const SELECT_DIALOG_KEY = {
  GROUP: 'group',
  ENTERPRISE: 'enterprise',
  STUDENT: 'student'
}

const ACTION_COLUMN = {
  title: '操作',
  dataIndex: 'action',
  width: 100,
  scopedSlots: { customRender: 'action' }
}

export const selectDialogConfigs = [
  {
    key: SELECT_DIALOG_KEY.GROUP,
    dispatchType: 2,
    title: '选择用户分组',
    buttonText: '选择分组',
    width: 900,
    rowKey: 'id',
    customPagination: true,
    idField: 'groupId',
    displayField: 'groupName',
    recordIdKey: 'id',
    getDisplayName: record => record.name,
    searchFields: [
      {
        slot: 'search_name',
        label: '用户分组名称',
        key: 'name',
        placeholder: '请输入用户分组名称'
      }
    ],
    columns: [
      { title: 'ID', dataIndex: 'id', width: 100 },
      { title: '分组名称', dataIndex: 'name' },
      ACTION_COLUMN
    ],
    cellSlots: [],
    queryParams: {
      name: ''
    }
  },
  {
    key: SELECT_DIALOG_KEY.ENTERPRISE,
    dispatchType: 3,
    title: '选择认证企业',
    buttonText: '选择认证企业',
    width: 900,
    rowKey: 'enterpriseId',
    customPagination: false,
    idField: 'enterpriseId',
    displayField: 'enterpriseName',
    recordIdKey: 'enterpriseId',
    getDisplayName: record => record.enterpriseFullName,
    searchFields: [
      {
        slot: 'search_enterprise',
        label: '企业全称',
        key: 'enterpriseFullName',
        placeholder: '请输入企业全称'
      }
    ],
    columns: [
      { title: '企业ID', dataIndex: 'enterpriseId', width: 100 },
      { title: '企业全称', dataIndex: 'enterpriseFullName' },
      ACTION_COLUMN
    ],
    cellSlots: [],
    queryParams: {
      enterpriseFullName: ''
    }
  },
  {
    key: SELECT_DIALOG_KEY.STUDENT,
    dispatchType: 4,
    title: '选择大学生认证',
    buttonText: '选择大学生',
    width: 1000,
    rowKey: 'id',
    customPagination: false,
    idField: 'studentId',
    displayField: 'studentName',
    recordIdKey: 'id',
    getDisplayName: record => record.name || record.phone || String(record.id),
    searchFields: [
      {
        slot: 'search_student_name',
        label: '姓名',
        key: 'name',
        placeholder: '请输入'
      },
      {
        slot: 'search_student_phone',
        label: '手机号',
        key: 'phone',
        placeholder: '请输入'
      }
    ],
    columns: [
      { title: 'ID', dataIndex: 'id', width: 90 },
      { title: '姓名', dataIndex: 'name', width: 120 },
      { title: '手机号', dataIndex: 'phone', width: 140 },
      { title: '证件号码', dataIndex: 'idNo', width: 180 },
      {
        title: '认证状态',
        dataIndex: 'certStatus',
        width: 100,
        scopedSlots: { customRender: 'certStatus' }
      },
      ACTION_COLUMN
    ],
    cellSlots: ['certStatus'],
    queryParams: {
      name: '',
      phone: ''
    }
  }
]

export function getSelectDialogConfigByDispatchType (dispatchType) {
  return selectDialogConfigs.find(item => item.dispatchType === dispatchType)
}

export function createSelectDialogQueryParams () {
  return selectDialogConfigs.reduce((result, item) => {
    result[item.key] = { ...item.queryParams }
    return result
  }, {})
}
